<template>
  <div class="manage" @click="outFiltrate">
    <!-- <myTitle til="团队管理"></myTitle> -->
    <main style="height: 100%;">
      <div class="memoryTab">
        <div class="btn">
          <div class="toProject" v-if="$independence" :class="{'privatization':privatization}" @click="addMember">+ 添加成员</div>
          <div class="toProject" v-if="!$independence" :class="{'privatization':privatization}" @click="toFy()">成员管理
          </div>
          <div class="toProject" v-if="!$independence" :class="{'privatization':privatization}" @click="toFy('wx')">
            微信邀请成员</div>
          <div class="toProject" v-if="schoolFlag" @click="addBatch">+ 批量添加</div>
          <div class="statistics" @click="jump">统计面板</div>
          <searchInput placeholder="输入用户名" @search="search" @setSearch="setSearch">
          </searchInput>
          <el-popover placement="bottom" width="200" trigger="manual" v-model="visible">
            <el-form class="filterForm" label-position="right" label-width="70px" :model="formLabelAlign">
              <el-form-item label="角色">
                <el-select v-model="formLabelAlign.roleId" placeholder="全部" @change="changeFiltrate">
                  <el-option label="全部" value></el-option>
                  <el-option v-for="(item,index) in roleList" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门">
                <el-cascader ref="industryCascader" v-model="formLabelAlign.departId" :options="treeList" :props="{ checkStrictly: true,children: 'children',
        label: 'name', value:'id',}" :show-all-levels="false" clearable @change="cascaderChange"></el-cascader>
              </el-form-item>
              <el-form-item v-if="!schoolEdition" label="擅长语言" :show-overflow-tooltip="true">
                <el-select v-model="formLabelAlign.lang" placeholder="全部" @change="changeFiltrate">
                  <el-option label="全部" value></el-option>
                  <el-option v-for="(item,index) in langDescList" :key="index" :label="item.tagName"
                    :value="item.tagCode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="!schoolEdition" label="擅长领域" :show-overflow-tooltip="true">
                <el-select v-model="formLabelAlign.domain" placeholder="全部" @change="changeFiltrate">
                  <el-option label="全部" value></el-option>
                  <el-option v-for="(item,index) in domainList" :key="index" :label="item.tagName"
                    :value="item.tagCode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="用户状态">
                <el-select v-model="formLabelAlign.status" placeholder="全部" @change="changeFiltrate">
                  <el-option label="全部" value="">
                  </el-option>
                  <el-option label="正常" value="1">
                  </el-option>
                  <el-option label="未激活" value="2">
                  </el-option>
                  <!-- <el-option label="未加入" value="3">
                  </el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item :label="schoolEdition ? '在校状态' : '在职状态'">
                <el-select v-model="formLabelAlign.positionStatus" placeholder="全部" @change="changeFiltrate">
                  <el-option label="全部" value></el-option>
                  <el-option :label="schoolEdition ? '在校' : '在职'" value="1"></el-option>
                  <el-option :label="schoolEdition ? '毕业' : '离职'" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-button v-if="!$privatization" class="sortFiltrate" slot="reference" @click.stop="onFiltrate">
              筛选
              <i class="el-icon--right" :class="iconCaret"></i>
            </el-button>
          </el-popover>
          <!-- <div v-if="!$privatization">
            <el-select class="pmselect" v-model="formLabelAlign.creatorId" placeholder="全部" v-if="pmUserList.length>1"
              @change="getPage(1)">
              <el-option label="全部" value></el-option>
              <el-option v-for="(item,index) in pmUserList" :key="index" :label="item.aliasName" :value="item.userId">
              </el-option>
            </el-select>
            <div class="pmselectName" v-if="pmUserList.length>1">项目经理：</div>
          </div> -->
        </div>
      </div>
      <template>
        <div class="table">
          <el-table :data="tableData" :header-cell-style="{background:'#EAEAEA',color:'#  454545',padding:'6.5px 0'}"
            @sort-change="sortChange" v-loading="loading">
            <template slot="empty">
              <div id="notDate">
                <img src="../../assets/imgs/memory/no_data.png" alt />
                <p>暂无数据，快去创建吧</p>
              </div>
            </template>
            <!-- <el-table-column label="头像" min-width="10">
              <template slot-scope="scope">
                <img class="headPortrait" :src="scope.row.avatar || uesrImg" alt />
              </template>
            </el-table-column> -->
            <el-table-column type="index" label="序号" min-width="10">
            </el-table-column>
            <el-table-column prop="aliasName" :show-overflow-tooltip="true" :label="$privatization ? '姓名':'用户名'"
              min-width="10">
            </el-table-column>
            <el-table-column prop="roleName" :show-overflow-tooltip="true" label="角色" sortable="custom" min-width="10">
            </el-table-column>
            <el-table-column prop="departName" v-if="!$privatization" :show-overflow-tooltip="true" :label="schoolEdition? '所属院系':'所属部门'"
              min-width="10">
            </el-table-column>
            <el-table-column prop="departName" v-if="schoolEdition" :show-overflow-tooltip="true" label="班级"
              min-width="10">
            </el-table-column>
            <el-table-column prop="email" v-if="schoolEdition" :show-overflow-tooltip="true" label="邮箱" min-width="10">
            </el-table-column>
            <el-table-column prop="loginPhone" :show-overflow-tooltip="true" :label="$privatization ? '用户名':'手机号'"
              min-width="20">
              <template slot-scope="scope">
                <span>{{scope.row.loginPhone || "--"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="langTagList" v-if="!$independence && !schoolEdition" :show-overflow-tooltip="true" label="擅长语言"
              min-width="10">
              <template slot-scope="scope">
                <span v-show="scope.row.langTagList.length>0" v-for="(item,index) in scope.row.langTagList"
                  :key="index">{{item.tagName}}&nbsp;</span>
                <span v-show="scope.row.langTagList.length<1">--</span>
              </template>
            </el-table-column>
            <el-table-column prop="domainTagList" v-if="!$independence && !schoolEdition" :show-overflow-tooltip="true" label="擅长领域"
              min-width="10">
              <template slot-scope="scope">
                <span v-show="scope.row.domainTagList.length>0" v-for="(item,index) in scope.row.domainTagList"
                  :key="index">{{item.tagName}}&nbsp;</span>
                <span v-show="scope.row.domainTagList.length<1">--</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" :show-overflow-tooltip="true" label="用户状态" min-width="10">
              <template slot-scope="scope">
                <div>
                  {{setStatus(scope.row.status)}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="endDate" v-if="!$privatization" :show-overflow-tooltip="true"
              :label="schoolEdition ? '在校状态' : '在职状态'" min-width="10">
              <template slot-scope="scope">
                <div>
                  {{setEndDate(scope.row.endDate)}}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop label min-width="10"></el-table-column> -->
            <el-table-column prop="creatorName" :show-overflow-tooltip="true" label="邀请人" min-width="10">
            </el-table-column>
            <el-table-column prop="date" v-if="$independence" label="操作" min-width="20">
              <template slot-scope="scope">
                <div class="operation">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
                    <i class="icon-edit" :class="{'privatization':privatization}" style="cursor:pointer;"
                      @click="updateMember(scope.$index, scope.row)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="二维码" placement="bottom">
                    <i class="icon-wxCode" :class="{'privatization':privatization}" style="cursor:pointer;"
                      @click="wxMessage(scope.row)" v-if="scope.row.status === 2 && !$privatization ?true :false"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                    <i class="icon-delete" :class="{'privatization':privatization}" style="cursor:pointer;"
                      @click="handleDelete(scope.$index, scope.row)"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="createTime" label="加入日期" :show-overflow-tooltip="true" sortable="custom"
              min-width="10"></el-table-column>
          </el-table>
          <el-pagination class="page" background layout="total,prev, pager, next" :total="totalRows" :page-size="20"
            :pager-count="5" :current-page.sync="currentPage" prev-text="上一页" next-text="下一页"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </template>

    </main>
    <messageBox v-if="mesBox" :isShow="mesBox" :tit="new_" txt mesShow="20" :imgSrc="imgSrc1" :ifForm="ifForm"
      :twoCode="twoCode" :again="again" @message="showMesBox" @messageIf="messageIf"></messageBox>

    <delMessage :isShow="isdelMessage" :txt="delTxt"></delMessage>
    <!-- <messageBox v-show="mesBox" tit="友情提示" txt="确定返回并清空文件吗？" :imgSrc="imgSrc1" @message="empty"></messageBox> -->
    <!-- 二维码弹窗补加开始 -->
    <div class="wxBox" v-show="wxShow">
      <div class="delMessage">
        <h5>
          二维码扫描
          <span @click="call">
            <!-- <img src="../../assets/imgs/message/popup_close_normal.png" alt /> -->
          </span>
        </h5>
        <div class="mainText">
          <img style="width: 140px;height: 140px;" :src="wxUrl" alt />
          <p class="twoCodeTxt">
            二维码可以下载到本地发送给成员。（有效期24小时）
            <a :href="wxUrl" download="二维码" v-if="schoolFlag">下载二维码</a>
            <a :href="this.baseURL+'/api/v1/file/download_wechat_qr_code?companyUserId='+again+'&fileUrl='+wxUrl"
              v-else>下载二维码</a>
          </p>
        </div>
        <div class="but">
          <button class="themeCallBut" @click="call">取消</button>
          <button class="themeGoBut" @click="call">确定</button>
        </div>
      </div>
      <div class="hide1" @click="call"></div>
    </div>
    <!-- 二维码补加结束 -->
  </div>
</template>

<script>

import myTitle from "@/common/title.vue";
// 
import delMessage from "@/common/delMessage.vue";
import messageBox from "@/common/messageBox.vue";
import { setTimeout } from "timers";
import searchInput from "@/common/searchInput.vue";
export default {
  name: "home",
  // props: ["new_", "merage", "tableData"],
  // props: ["new_", "merage"],
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    if (from.path != "/") {
      // 如果不是刷新则赋值1
      sessionStorage.removeItem("myCurrentPage");
    }
    next();
  },
  data() {
    return {
      tableData: [],
      value1: "",
      value2: "",
      value3: "",
      mesBox: false,
      mesShow: "",
      imgSrc1: require("../../assets/imgs/project/qr_code_bg.png"), // 弹窗title背景图
      mestit: "", // 弹窗title
      thisRow: "",
      compile: "",
      currentPage: "",
      new_: "",
      isdelMessage: false,
      delRow: "",
      delTxt: "",
      ifForm: "", // 这里的代表是否显示角色
      search_mod: "",
      sort: "",
      totalRows: 0, // 分页数据总数
      loading: true,
      twoCode: "",
      again: "",
      wxShow: false,
      wxUrl: "",
      uesrImg: require("../../assets/imgs/manage/little_head.png"),
      curThead: [],
      role_id: "",
      aliasName: "",
      visible: false,
      formLabelAlign: {
        // domain: "",
        // lang: "",
        // creatorId: "",
        // status: "",
        // roleId: ""
      },
      domainList: [],
      langDescList: [],
      roleList: [],
      pmUserList: [],
      iconCaret: "el-icon-caret-bottom",
      tableHeight: window.innerHeight * 0.675,
      updateUser: "", // 用于修改
      privatization: false,
      schoolFlag: false,
      schoolEdition: false,
      treeList: []
    };
  },
  created() {
    // if (process.env.VUE_APP_PLATFORMTYPE === "5" || process.env.VUE_APP_PLATFORMTYPE === "2") {
    //   this.schoolEdition = true;
    // }
    if (process.env.VUE_APP_NAME == "school") {
      this.schoolFlag = true;
      this.schoolEdition = true;
    } else {
      this.schoolFlag = false
    }
    let myUser = JSON.parse(localStorage.getItem("myUser"))
    const lastSelectCompany = JSON.parse(localStorage.lastSelectCompany)
    // myUser = JSON.parse(myUser); //把字符串转换成JSON对象
    console.log(myUser)
    if (this.$privatization && lastSelectCompany.role) {
      if (lastSelectCompany.role.name === "项目经理") {
        this.privatization = true
      }
    }
    this.currentPage = Number(sessionStorage.getItem("myCurrentPage")) || 1;
    this.getPage(this.currentPage);
    this.getPmUserList();
  },
  methods: {
    //     handleTheadAddClass({row, column, rowIndex, columnIndex}){
    //       // console.log(column)
    //     // 判断找到当前列 添加样式
    //     this.curThead.forEach(item=>{
    //       if( column.property == item ){
    //        return 'active-thead'
    //     }
    //     })
    // if (role_id) {
    //   this.$nextTick(()=>{
    //     document.getElementsByClassName("sort-caret").styl
    //   })
    // }

    // },
    cascaderChange(val) {
      if (!val) {
        return
      }
      const lenLength = this.$refs.industryCascader.getCheckedNodes()[0].path.length - 1;
      const industryId = this.$refs.industryCascader.getCheckedNodes()[0].path[lenLength];
      this.formLabelAlign.departId = industryId;
    },
    queryListTree() {
      let that = this;
      this.catReq1Service("/api/v1/company/depart/queryListTree", {
        companyCode: localStorage.myCompanyCode
      })
        .then(function (response) {
          if (!response.success) {
            return;
          }
          that.treeList = response.result;
        });

    },
    toFy(name) {
      if (name === "wx") {
        window.location.href = PTURL + "perCenter/weixinInvite?companyCode=" + localStorage.myCompanyCode
        return
      }
      window.location.href = PTURL + "perCenter/team"

    },
    setStatus(status) {
      switch (status) {
        case 0:
          return "禁用"
          break;
        case 1:
          return "正常"
          break;
        case 2:
          return "未激活 "
          break;
        default:
          break;
      }
    },
    setEndDate(time) {
      if (!time) {
        return this.schoolEdition ? "在校" : "在职"
      }
      if (new Date(time) > new Date()) {
        return this.schoolEdition ? "在校" : "在职"
      } else {
        return this.schoolEdition ? "毕业" : "离职"
      }
    },
    setSearch(data) {
      this.search_mod = data;
    },
    jump() {
      this.$router.push("/home/projectHome/reportForm");
    },
    // 获取项目经理下拉选列表标签  项目经理分组
    getPmUserList() {
      var that = this;
      this.catReq1Service("/api/v1/companyUser/queryPmUserList", {
        type: 2
      })
        .then(function (response) {
          if (!response.success) {
            return;
          }
          that.pmUserList = response.result;
        });
    },
    // 获取领域下拉选列表标签
    getDomainList() {
      var that = this;
      this.catReq1Service("/api/v1/companyUser/queryCompanyTag", {
        type: 2,
        active: 1
      })
        .then(function (response) {
          if (!response.success) {
            return;
          }
          that.domainList = response.result;
        });
    },
    // 获取语言对下拉选列表标签
    getLangDescList() {
      var that = this;

      this.catReq1Service("/api/v1/companyUser/queryCompanyTag", {
        type: 1,
        active: 1
      })
        .then(function (response) {
          if (!response.success) {
            return;
          }
          that.langDescList = response.result;
        });
    },
    // 获取项目经理列表
    getRoleList() {
      var that = this;
      this.catReq1Service("/api/v1/role/querySelfRoleList").then(function (response) {
        if (!response.success) {
          return;
        }
        that.roleList = response.result;
      });
    },
    changeFiltrate() {
      this.currentPage = 1;
      sessionStorage.setItem("myCurrentPage", 1);
      this.getPage(1, this.search_mod, this.sort)
    },
    // 关闭筛选
    outFiltrate() {
      if (this.visible) {
        this.visible = false;
        this.iconCaret = "el-icon-caret-bottom";
        this.currentPage = 1;
        sessionStorage.setItem("myCurrentPage", 1);
        this.getPage(1, this.search_mod, this.sort);
      }
    },
    // 筛选
    onFiltrate() {
      this.visible = !this.visible;
      if (!this.visible) {
        this.iconCaret = "el-icon-caret-bottom";
        this.currentPage = 1;
        sessionStorage.setItem("myCurrentPage", 1);
        this.getPage(1, this.search_mod, this.sort);
      } else {
        this.formLabelAlign = {
          domain: "",
          lang: "",
          creatorId: "",
          status: "",
          roleId: "",
          positionStatus: "",
          departId: ""
        }
        this.iconCaret = "el-icon-caret-top";
        this.getDomainList();
        this.getLangDescList();
        this.getRoleList();
        this.queryListTree()
      }
    },
    // 排序
    sortChange({ column, prop, order }) {
      if (!order) {
        this.curThead.push(prop);
      }
      if (order == "descending") {
        order = "desc";
      } else if (order == "ascending") {
        order = "asc";
      }
      if (prop == "createTime") {
        // 时间
        // this.create_time = order
        this.sort = { createTime: order };
        this.getPage(this.currentPage, this.search_mod, { createTime: order });
      } else {
        // 角色
        this.role_id = order;
        this.sort = { roleId: order };
        this.getPage(this.currentPage, this.search_mod, { roleId: order });
      }
    },
    // 搜索
    search() {
      this.search_mod = this.search_mod.replace(
        /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
        ""
      );
      sessionStorage.setItem("myCurrentPage", 1); // 将页码存sessionStorage，刷新还在当前页
      this.getPage("1", this.search_mod);
    },
    // 跳转页
    handleCurrentChange(val) {
      this.getPage(val, this.search_mod, this.sort);
      sessionStorage.setItem("myCurrentPage", val); // 将页码存sessionStorage，刷新还在当前页
    },
    // 分页加载数据
    getPage(page, search, sort) {
      var that = this;

      var filter = this.formLabelAlign;
      filter.aliasName = search;
      for (let propName in filter) {
        if (filter[propName] === "") {
          delete filter[propName];
        }
      }
      var params = {
        page: page,
        rows: 20,
        filter: {
          companyCode: localStorage.myCompanyCode,
          platformType: this.$platformType, ...filter
        },
        sort: sort || { createTime: "desc" }
      };
      this.catReq1Service("/api/v1/companyUser/queryPage", params)
        .then(function (response) {
          if (!response.success) {
            return;
          }
          that.loading = false;
          let data = response.list;
          if (data == null) {
            data = [];
          }
          that.totalRows = response.totalRows || 0;
          that.tableData = data;
          if (that.currentPage > 1 && that.tableData.length < 1) {
            sessionStorage.myCurrentPage = sessionStorage.myCurrentPage - 1;
            that.currentPage - 1;
            that.getPage(
              sessionStorage.myCurrentPage,
              that.search_mod,
              that.sort
            );
          }
          that.tableData.forEach(item => {
            item.createTime = that.dateReg(item.createTime);
            // if (item.status == 1) {
            //   item.status = "已加入";
            // } else {
            //   item.status = "未扫码加入";
            // }
          });
        });
    },
    // --确定键事件
    showMesBox(data) {
      let reg = /^1\d{10}$/;
      var that = this;
      let updateUser = that.$store.state.updateUser;
      that.new_ == "添加成员" ? updateUser = data : '';
      if (updateUser) {
        updateUser.aliasName = updateUser.aliasName.replace(
          /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
          ""
        );
      }

      if (!this.detection(updateUser.aliasName || "")) {
        return;
      }
      if (that.new_ == "添加成员" && this.$privatization) {  // 私有化添加
        if (!this.detection(updateUser.loginPhone || "", "", "用户名", false)) {
          return;
        }
        if (!this.detection(updateUser.aliasName || "", "", "姓名", false)) {
          return;
        }
        const params = {
          aliasName: updateUser.aliasName,
          loginPhone: updateUser.loginPhone,
          password: updateUser.password,
          roleId: updateUser.roleId,
        }
        this.catReq1Service("/api/v1/companyUser/addProjectManager", params)
          .then(function (response) {
            if (!response.success) {
              return;
            }
            that.$message({
            message: "添加成功",
            type: "success"
          });
            that.getPage(sessionStorage.myCurrentPage, that.search_mod, that.sort);
            that.getPmUserList();
            that.mesBox = false;
          });
      } else {
        // if (that.aliasName === updateUser.aliasName) {
        //   that.$message({
        //     message: "新用户名与原用户名一致",
        //     type: "warning"
        //   });
        //   return;
        // }
        if (updateUser.aliasName.length > 16) {
          that.$message({
            message: "姓名长度不超过16个字符",
            type: "warning"
          });
          return;
        }
        if (this.$privatization) { // 私有化修改
          this.privatizationUpdate(updateUser, data)
          return
        }
        // // 修改手机号  判断手机号格式是否正确
        if (updateUser.loginPhone !== undefined) {
          if (!reg.test(updateUser.loginPhone)) {
            that.$message({
              message: "请输入正确的手机号",
              type: "warning"
            });
            return
          }
        }
        that.mesBox = false;
        let domainTagList = [];
        let langTagList = [];
        that.updateUser.langTagList.forEach(item => {
          langTagList.push({
            tagCode: item.tagCode,
            tagName: item.tagName
          });
        });
        that.updateUser.domainTagList.forEach(item => {
          domainTagList.push({
            tagCode: item.tagCode,
            tagName: item.tagName
          });
        });

        //语言
        let isDeleteLang = true;
        let addLangList = updateUser.langDesc;
        let arrLang = JSON.parse(JSON.stringify(langTagList));
        let aryLang = JSON.parse(JSON.stringify(addLangList));
        for (let i = 0; i < aryLang.length; i++) {
          for (let j = 0; j < arrLang.length; j++) {
            if (aryLang[i] && aryLang[i].tagCode === arrLang[j].tagCode) {
              // 删除元素后改变i的值
              aryLang.splice(i--, 1);
            }
          }
        }
        for (let i = 0; i < langTagList.length; i++) {
          for (let j = 0; j < addLangList.length; j++) {
            if (langTagList[i] && langTagList[i].tagCode === addLangList[j].tagCode) {
              // 删除元素后改变i的值
              langTagList.splice(i--, 1);
            }
          }
        }

        let isDeleteDomain = true;
        let addList = updateUser.domain
        let arr = JSON.parse(JSON.stringify(domainTagList));
        let ary = JSON.parse(JSON.stringify(addList));
        for (let i = 0; i < ary.length; i++) {
          for (let j = 0; j < arr.length; j++) {
            if (ary[i] && ary[i].tagCode === arr[j].tagCode) {
              // 删除元素后改变i的值
              ary.splice(i--, 1);
            }
          }
        }
        for (let i = 0; i < domainTagList.length; i++) {
          for (let j = 0; j < addList.length; j++) {
            if (domainTagList[i] && domainTagList[i].tagCode === addList[j].tagCode) {
              // 删除元素后改变i的值
              domainTagList.splice(i--, 1);
            }
          }
        }
        var params = {
          id: that.compile.id,
          aliasName: updateUser.aliasName,
          deleteLangTagList: langTagList,
          deleteDomainTagList: domainTagList,
          addDomainTagList: ary,
          addLangTagList: aryLang,
          loginPhone: updateUser.loginPhone,
        };

        if (that.aliasName === updateUser.aliasName) { // 未更用户名则不传
          delete params.aliasName;
        }
        if (aryLang.length < 1 && langTagList.length < 1) { // 未更改语言则不传
          delete params.addLangTagList;
          delete params.deleteLangTagList;
        }
        if (ary.length < 1 && domainTagList.length < 1) { // 未更改领域则不传
          delete params.addDomainTagList;
          delete params.deleteDomainTagList;
        }
        if (   // 未更改则return
          !params.hasOwnProperty('addDomainTagList') &&
          !params.hasOwnProperty('addLangTagList') &&
          that.aliasName === updateUser.aliasName &&
          that.loginPhone === updateUser.loginPhone
        ) {
          return;
        }
        this.catReq1Service("/api/v1/companyUser/update", params)
          .then(function (response) {
            if (!response.success) {
              return;
            }
            that.getPage(sessionStorage.myCurrentPage, that.search_mod, that.sort);
            that.getPmUserList();
          });
      }
    },
    // 私有化修改
    privatizationUpdate(updateUser, data) {
      if (!data) {
        this.mesBox = false;
        return
      }
      let that = this;
      that.mesBox = false;
      let params = {
        id: that.compile.id,
        aliasName: data.aliasName,
        userId: 0,
        flag: Number(data.flag)
      };
      this.catReq1Service("/api/v1/companyUser/updateUserPassWord", params)
        .then(function (response) {
          if (!response.success) {
            return;
          }
          // that.mesBox = false;
          that.$message({
            message: '修改成功',
            type: 'success'
          });
          that.getPage(sessionStorage.myCurrentPage, that.search_mod, that.sort);
          that.getPmUserList();
        });
    },
    messageIf(callBut) {
      this.mesBox = false;
      // 添加完刷新
      this.formLabelAlign = {
        domain: "",
        lang: "",
        creatorId: "",
        status: "",
        roleId: "",
        positionStatus: "",
        departId: ""
      }
      this.search_mod = ""
      this.getPage(1);
    },
    // 二维码补加开始
    wxMessage(row) {
      if (this.privatization) {
        return
      }
      var that = this;
      if (row) {
        that.again = row.id;
      }
      that.getWxCode();
      that.wxShow = true;
    },
    getWxCode() {
      var that = this;
      this.catReq1Service("/api/v1/companyUser/createQrcode", { id: this.again })
        .then(function (response) {
          if (!response.success) {
            return;
          }
          that.wxUrl = response.result.url;
        });
    },
    // 二维码补加结束
    // 添加成员弹窗
    addMember(index, row) {
      if (this.privatization) {
        return
      }
      var that = this;
      that.ifForm = 1;
      that.new_ = "添加成员";
      that.again = 0;
      if (that.mesBox) {
        that.mesBox = false;
      } else {
        that.mesBox = true;
      }
    },
    async addBatch() {
      const res = await this.catReq1Service("/api/v1/companyUser/createTeamQrCode", {});
      if (res.success) {
        this.wxUrl = 'data:image/png;base64,' + res.result.urlBase64;
      }
      this.wxShow = true;
    },
    // 修改成员
    updateMember(index, row) {
      if (this.privatization) {
        return
      }
      var that = this;
      that.ifForm = 0;
      that.compile = row;
      that.updateUser = row;
      that.$store.commit("setUpdateUser", row);
      that.aliasName = row.aliasName;
      that.loginPhone = row.loginPhone;
      that.new_ = "修改成员";
      if (that.mesBox) {
        that.mesBox = false;
      } else {
        that.mesBox = true;
      }
    },
    /* 删除开始*/
    call() {
      this.isdelMessage = false;
      this.wxShow = false;
    },
    del() {
      var that = this;
      this.isdelMessage = false;
      var params = {
        id: this.delRow.id
      };
      this.catReq1Service("/api/v1/companyUser/delete", params).then(function (response) {
        if (!response.success) {
          return;
        }
        that.$message({
            message: "删除成功",
            type: "success"
          });
        that.getPage(sessionStorage.myCurrentPage, that.search_mod, that.sort);
      });
    },
    handleDelete(index, rows) {
      if (this.privatization) {
        return
      }
      var that = this;

      that.delTxt = "确定删除该" + rows.roleName + "吗？";
      that.delIndex = index;
      that.delRow = rows;
      that.isdelMessage = true;
    }
    /* 删除结束*/
  },

  components: {
    myTitle,
    messageBox,
    delMessage,
    searchInput
  }
};
</script>
<style lang="less" scoped>
// 二维码补加开始
.wxBox {
  .hide1 {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0.7;
    z-index: 888;
  }
  .delMessage {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(76, 76, 76, 0.8);
    border-radius: 10px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    opacity: 1;
    h5 {
      border-bottom: 1px solid #dfe4e8;
      width: 90%;
      margin: 0 auto;
      height: 48px;
      line-height: 48px;
      border-radius: 10px 10px 0px 0px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      position: relative;
      span {
        position: absolute;
        right: 10px;
        img {
          cursor: pointer;
          -webkit-transition: -webkit-transform 0.6s ease-out;
          -moz-transition: -moz-transform 0.6s ease-out;
          transition: transform 0.6s ease-out;
        }
        img:hover {
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          transform: rotate(180deg);
        }
      }
    }
    .mainText {
      margin: 50px 0px;
      font-size: 16px;
      width: 450px;
      p {
        margin: 0 auto;
        margin-top: 20px;
        width: 193px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(69, 69, 69, 1);
        a {
          font-weight: bold;
          color: #222222;
        }
      }
    }
    .but {
      padding-bottom: 30px;
      margin: 0 80px;
      button {
        // width: 80px;
      }
      button:nth-child(2) {
        margin-left: 30px;
      }
    }
  }
}
// 二维码补加结束
.memoryTab {
  .search {
    position: absolute;
    right: 128px;
    top: 10px;
    cursor: pointer;
  }
  .img {
    width: 140px;
    height: 140px;
  }
  .btn > div {
    margin-right: 20px;
  }
  .btn {
    position: relative;
    height: 38px;
    // float: right;
    margin-bottom: 10px;
    span {
      float: right;
      margin-right: 20px;
      .sortFiltrate {
        float: right;
        width: 100px;
        height: 36px;
        border: 0px;
        color: black;
        background: #f5f4f4;
        // line-height: 36px;
      }
    }
    .pmselect {
      float: right;
      /deep/.el-input {
        width: 100px !important;
        input::-webkit-input-placeholder {
          color: #000;
        }
        .el-input__inner {
          background: #f5f4f4;
        }
      }
    }
    .pmselectName {
      float: right;
      height: 36px;
      line-height: 36px;
    }
  }
}
.toProject {
  width: 92px;
  height: 32px;
  line-height: 32px;
  background: #5256e9;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  float: left;
}
.statistics {
  width: 92px;
  height: 32px;
  line-height: 32px;
  background: #767af5;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  float: left;
}
main {
  // background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  // margin-top: 20px;
  background: #f5f4f4;
  padding: 20px;
  padding-top: 10px;
  position: relative;
  // min-height: 743px;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover {
  //   box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
  .operation {
    display: block;
    height: 23px;
  }
}
.el-table {
  background: #f5f4f4;
  .operation {
    margin-top: 4px;
    height: 23px;
    display: none;
    i {
      display: inline-block;
      margin: 0 7px;
      width: 20px;
      height: 20px;
    }
  }

  .operation2 {
    // margin-top: 4px;
    display: flex;
    justify-content: center;
    i {
      display: inline-block;
      margin: 0 7px;
      width: 20px;
      height: 20px;
    }
  }

  .icon-wxCode {
    background: url("../../assets/imgs/manage/sweep_code_normal.png") no-repeat;
  }
  .icon-wxCode:hover {
    background: url("../../assets/imgs/manage/sweep_code_hover.png") no-repeat;
  }
  .icon-wxCode:active {
    background: url("../../assets/imgs/manage/qr_code_press.png") no-repeat;
  }
  .icon-edit {
    background: url("../../assets/imgs/manage/edit_normal.png") no-repeat;
  }
  .icon-edit:hover {
    background: url("../../assets/imgs/manage/edit_hover.png") no-repeat;
  }
  .icon-edit:active {
    background: url("../../assets/imgs/manage/edit_press.png") no-repeat;
  }
  .icon-delete {
    background: url("../../assets/imgs/project/delete_normal.png") no-repeat;
  }
  .icon-delete:hover {
    background: url("../../assets/imgs/project/delete_hover.png") no-repeat;
  }
  .icon-delete:active {
    background: url("../../assets/imgs/project/delete_press.png") no-repeat;
  }
}
.headPortrait {
  width: 30px;
  height: 30px;
  border-radius: 15px;
}
.manage {
  // 表格样式开始
  /deep/.el-table {
    .el-table__empty-block {
      // 修改无数据 出现滚动条
      height: 90% !important;
    }
  }
  /deep/.el-table__row td .cell {
    padding: 3px 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  #notDate {
    // 暂无数据
    // margin-top: 80px;
  }
  .el-table {
    margin: 0 auto;
    height: calc(100% - 70px);
    /deep/.row-expand-cover .el-table__expand-icon {
      visibility: hidden;
    }
    /deep/th {
      text-align: center;
    }
    /deep/.el-table__expanded-cell {
      padding: 0;
      padding-left: 20px;
      border-bottom: 0px;
    }
    /deep/.el-table__expanded-cell:hover {
      background: #fff !important;
    }
  }
  /deep/.el-table::before {
    height: 0px;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr {
    background: #f5f4f4;
  }
  // /deep/.el-table tr th:nth-child(4) {
  //   text-align: left;
  // }
  /deep/.el-table td,
  .el-table th {
    // 修改table行高
    padding: 4px 0px !important;
    //   height: 36px !important;
    font-size: 12px;
  }
  /deep/.el-table td {
    text-align: center;
  }
  // /deep/.el-table td:nth-child(4) {
  //   text-align: left;
  // }
  /deep/.el-table th.is-leaf {
    border-bottom: 0px;
  }
  //   /deep/.el-table .el-table .el-table  td:nth-child(2) {
  //     text-align: center;
  //   }
  /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
    box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    // table 鼠标滑动效果
    background: rgba(210, 210, 210, 1);
  }
  // 表格样式结束
  /* 页码样式开始 */
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    // 页码点击效果
    // background: rgba(69, 69, 69, 1);
    color: rgba(255, 255, 255, 1);
    border: 0px;
  }
  /deep/.el-pager li {
    // 页码样式
    min-width: 30px;
    height: 30px;
    border: 1px solid rgba(187, 187, 187, 1);
    border-radius: 2px;
    background: transparent;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
  }
  /deep/.el-pagination button {
    // 页码上下页样式
    width: 68px;
    height: 30px;
    border: 1px solid rgba(187, 187, 187, 1);
    border-radius: 2px;
    line-height: 30px;
    font-size: 14px;
    background: transparent;
    color: rgba(102, 102, 102, 1);
    font-weight: 400;
  }
  /deep/.el-pagination button:hover {
    border: 1px solid rgba(128, 128, 128, 1);
  }
  /deep/.el-pagination button:active {
    background: rgba(224, 237, 252, 1);
    border: 1px solid rgba(187, 187, 187, 1);
  }
  .page {
    position: absolute;
    bottom: 20px;
    right: 0px;
  }
  /* 页码样式结束 */
  // .table >>> .active-thead .sort-caret.descending{        border-top-color: #409eff;
  //   }    .table >>> .active-thead .sort-caret.ascending{        border-top-color: #409eff;
  //   }
}
/deep/.el-select .el-input {
  width: 100%;
}
.filterForm {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
<style lang="less">
.privatization {
  cursor: no-drop !important;
}
.manage {
  height: calc(100% - 40px);
  main {
    .table {
      height: calc(100% - 18px);
      overflow: auto;
      position: relative;
      // .el-table__body {
      //   border-collapse: separate !important;
      //   border-spacing: 0px 8px !important;
      // }
    }
  }
}
</style>
<style lang="less">
.el-table__body-wrapper {
  overflow-y: auto;
  height: calc(100% - 65px);
}
</style>